export const al = new URL('./al.png', import.meta.url) + '';
export const baidu = new URL('./baidu.png', import.meta.url) + '';
export const huawei = new URL('./huawei.png', import.meta.url) + '';
export const ql = new URL('./ql.png', import.meta.url) + '';
export const sf = new URL('./logo-b.svg', import.meta.url) + '';
export const zs = new URL('./zs.png', import.meta.url) + '';
